import { ArrowUpRight } from "lucide-react";
import { catLabel } from "../lib/api";

export const WebPickCard = ({ item, index, testId }) => (
  <a
    href={item.url}
    target="_blank"
    rel="noopener noreferrer"
    className="group relative flex flex-col h-full border-t-2 border-ink pt-5 pb-8 pr-4 transition-colors duration-300 hover:bg-blush/60"
    data-testid={testId}
  >
    <div className="flex items-start justify-between gap-4">
      <span className="display text-5xl text-pink leading-none">{String(index + 1).padStart(2, "0")}</span>
      <span className="h-10 w-10 shrink-0 grid place-items-center rounded-full border border-ink/25 transition-[background-color,transform,border-color] duration-500 group-hover:bg-hot group-hover:border-hot group-hover:rotate-45">
        <ArrowUpRight className="h-4 w-4" />
      </span>
    </div>
    <p className="kicker text-rose mt-5">{catLabel(item.category)}</p>
    <h3 className="display text-2xl sm:text-[1.7rem] leading-[1.02] mt-2 group-hover:text-rose transition-colors">{item.title}</h3>
    <p className="font-serif italic text-lg text-ink/75 mt-3 leading-snug">{item.summary}</p>
    <p className="kicker text-ink/60 mt-auto pt-5">Read on {item.source} ↗</p>
  </a>
);
